const withdrawStatus: Record<string, string> = {
    created: 'در انتظار پرداخت',
    accepted: 'تایید شده',
    send_shaparak: 'ارسال برای شاپرک',
    rejected: 'رد شده',
};

export const getWithdrawStatusLabel = (status: string): string => {
    return withdrawStatus[status];
};
